module.exports = __webpack_public_path__ + "img/details-banner.6578f6d3.png";